import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Page } from "@/components";
import { ProfileView } from "@/views";
import { getCanonicalAndLanguageAlternates, getChainInfo } from "@/utils";

const ProfilePage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  const title = "Profile";
  const description = "Browse and customize your profile settings on YOLO Games.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    `/settings/profile/`,
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={title}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/meta.png`,
              alt: "Profile",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <ProfileView />
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

export default ProfilePage;
